import React from 'react';
import { useSelector } from 'react-redux';


import ContentComponent from '../../components/Content';

const Content = (props) => <ContentComponent {...props} />;

const ContentContainer = (props) => {
  const state = useSelector((state) => ({
    homeHub: state.homeHub.homeHub || []
  }));

  const actions = {};

  return <Content {...props} {...state} {...actions} />;
};

export default ContentContainer;
